export default {"src":"/_next/static/media/share_secondary.83ecca83.svg","height":36,"width":38,"blurWidth":0,"blurHeight":0};